<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2025-03-17 14:21:38
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-10-10 17:11:58
 * @FilePath: \qctsw-vue\packages\app\src\pages\list\red-black.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import { timeFormat } from '@qctsw/utils'
import { useRedBlackWeekPage } from './hooks/redBlack'
import type { DayRedBlackResponse, RedBlackResponse } from '~/server/types'

const {
  type,
  currentYear,
  yearOptions,
  getMore,
  list,
  pagination,
  weekState,
  dayState,
  state,

  initHandler,
  weekPagination,
  dayPagination,
} = useRedBlackWeekPage()

await initHandler()
</script>

<template>
  <div class="public-container public-page">
    <div class="flex items-center">
      <div class="flex items-center">
        <NuxtLink
          class="border-1 border-slate-2 px-sm py-1 rounded-l"
          :to="APP_ROUTER.redAndBlackList()"
          :class="[type === 'week' ? 'bg-blue-5 text-white' : '']"
        >
          周榜
        </NuxtLink>
        <NuxtLink
          class="border-1 border-slate-2 border-l-0 px-sm py-1 rounded-r"
          :to="APP_ROUTER.redAndBlackList({ type: 'day' })"
          :class="[type === 'day' ? 'bg-blue-5 text-white' : '']"
        >
          日榜
        </NuxtLink>
      </div>
      <NSelect v-if="type === 'week'" v-model:value="currentYear" class="w-40 ml-sm" :options="yearOptions" placeholder="请选择红黑榜年份" />
    </div>
    <div v-if="type === 'week'" class="mt-xl p-3 border-1 border-red-5 text-red-5 tracking-tight">
      每周发布一次，主要依据企业上周对投诉处理的态度、效率以及投诉 人对处理结果的认可度综合评定计算出最好和最差的企业，是体现企业投诉处理好坏的最体
      表现。登陆红榜一次，可在年终的积分排行榜中额外增加一分，黑榜则扣减一分。
    </div>

    <UtilLoadState :state="state" type="up" :length=" 10" :reload-handler="initHandler">
      <baseList :state="state" @load="getMore">
        <template v-if="type === 'week' && list.length">
          <div v-for="(v, i) in (list as RedBlackResponse[])" :key="i" class="mt-8">
            <BasicTitle v-if="v.periods" :title="`第${v.periods}期`">
              <template #after>
                <p class="text-3.5 tracking-0">
                  {{ `${timeFormat(v.startTime, 'YYYY/MM/DD')} - ${timeFormat(v.endTime, 'YYYY/MM/DD')}` }}
                </p>
              </template>
            </BasicTitle>
            <div class="mt-6 shadow rounded overflow-hidden">
              <RedBlackContainer
                v-if="v" :data="v"
                :day-params="{
                  weekEndTime: timeFormat(v.endTime, 'YYYY-MM-DD'),
                  weekStartTime: timeFormat(v.startTime, 'YYYY-MM-DD'),
                }"
              />
            </div>
          </div>
        </template>
        <template v-else-if="type === 'day' && list.length">
          <div v-for="(v, i) in (list as DayRedBlackResponse[])" :key="i" class="mt-8">
            <BasicTitle :title="`${`${timeFormat(v.createTime, 'MM/DD')}  ${v.title}`}`" />
            <div class="mt-6 shadow rounded overflow-hidden">
              <RedBlackDay :data="v" />
            </div>
          </div>
        </template>

        <BasicEmpty v-else />
      </baseList>
    </UtilLoadState>
    <!-- <BasicPagination
      v-if="pagination.pagination.pageCount"
      class="mb-xl mt-4xl w-100 mx-auto"
      :page="pagination.pagination.page"
      :total="pagination.pagination.pageCount"
      :to="(page) => APP_ROUTER.redAndBlackList({ type, page })"
    /> -->
  </div>
</template>

<style lang='scss' scoped>

</style>
